import { ReactNode } from 'react';

import { useTheme } from '@mui/material';

import { HexIcon, Icons, Box, Stack } from '@cast/design-system';

type RemoveCenteredLayoutProps = {
  heading: ReactNode;
  description: ReactNode;
  actions: ReactNode;
};

export const RemoveCenteredLayout = ({
  heading,
  description,
  actions,
}: RemoveCenteredLayoutProps) => {
  const { palette } = useTheme();

  return (
    <Stack
      alignSelf="center"
      alignItems="center"
      gap="8px"
      width="360px"
      my="auto"
    >
      <HexIcon
        variant="error"
        display="flex"
        alignSelf="center"
        marginTop={-42}
        size={84}
        animationType="pulsateSlow"
        icon={
          <Icons.TrashSimple size={16} color={palette.red[500]} weight="fill" />
        }
      />

      <div>{heading}</div>
      <div>{description}</div>
      <Box mt="16px" mb="32px">
        {actions}
      </Box>
    </Stack>
  );
};
